<template>
  <v-chip v-if="newReservations !== 0" color="red" text-color="white" small>{{
    newReservations
  }}</v-chip>
</template>

<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'ReservationsNewStatusChip',

  computed: {
    ...mapState('reservations_new_status_badge', ['newReservations'])
  },

  mounted() {
    this.getQuantityNewReservations();
    this.getActualQuantityNewReservations();
  },

  methods: {
    ...mapCacheActions('reservations_new_status_badge', [
      'getActualQuantityNewReservations',
      'getQuantityNewReservations'
    ])
  }
};
</script>
